module.exports = __webpack_public_path__ + "img/1.87467f72.svg";